//export const IMS_WEBSITE = 'https://ims.hostlinguere.net/';
export const IMS_WEBSITE = 'https://erp.ivorymontessorisystem.com/';


// BRANDON
/*
export const BASEURL = 'https://ims.hostlinguere.net';
export const BASEURL_IMG = 'https://hostlinguere.net:8443/resources';
export const BASEURL_RESOURCES = 'https://hostlinguere.net:8443/resources';
export const SOCKET_URL = 'wss://hostlinguere.net:8081/api/v1/ws';
export const HTTP_MESSAGE_URL = 'https://hostlinguere.net:8081/api/v1';
*/

/*

export const BASEURL = 'http://localhost:3000';
export const BASEURL_IMG = 'http://192.168.1.97:8080/resources';
export const BASEURL_RESOURCES = 'http://192.168.1.97:8080/resources';
export const SOCKET_URL = 'ws://192.168.1.77:8081/api/v1/ws';
export const HTTP_MESSAGE_URL = 'http://192.168.1.97:8081/api/v1';
*/




export const BASEURL = 'https://erp.ivorymontessorisystem.com';
export const BASEURL_IMG = 'https://ivorymontessorisystem.com/imsv3/resources';
export const BASEURL_RESOURCES = 'https://ivorymontessorisystem.com/imsv3/resources';
export const SOCKET_URL = 'wss://ivorymontessorisystem.com/imsv3/api/v1/ws';
//export const HTTP_MESSAGE_URL = '/api/v1';
export const HTTP_MESSAGE_URL = 'https://ivorymontessorisystem.com/imsv3/api/v1';

// The gateway authenticates the WebSocket handshake with the same httpOnly auth
// cookie used for the REST calls: the browser attaches it automatically, so there
// is no ?token= query parameter (the token is not readable from JS).
export const getSocketURL = () => {
    return SOCKET_URL;
};


// PROD CONFIG33
/*
export const BASEURL = 'https://erp.ivorymontessorisystem.com';
export const BASEURL_IMG = 'https://ivorymontessorisystem.com/resources';
export const BASEURL_RESOURCES = 'https://ivorymontessorisystem.com/resources';
export const SOCKET_URL = 'wss://ivorymontessorisystem.com:8081/api/v1/ws';
export const HTTP_MESSAGE_URL = 'https://ivorymontessorisystem.com:8081/api/v1';

// The gateway authenticates the WebSocket handshake with the same httpOnly auth
// cookie used for the REST calls: the browser attaches it automatically, so there
// is no ?token= query parameter (the token is not readable from JS).
export const getSocketURL = () => {
    return SOCKET_URL;
};

*/
